import { useQuery } from "@tanstack/react-query";
import { listOrgRoles } from "@/api/client";

export interface OrgUser {
  uid: string;
  email: string;
  displayName: string;
  role: string;
}

export function useOrgUsers() {
  return useQuery({
    queryKey: ["orgUsers"],
    queryFn: async () => {
      const res = await listOrgRoles();
      return (res.assignments ?? []) as OrgUser[];
    },
    staleTime: 5 * 60 * 1000,
  });
}
